/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getAmazonProductVariants.internal

import features.getAmazonProductVariants.models.RewardResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.getAmazonProductVariants.internal.GetAmazonProductVariantsUseCase.Params

internal class GetAmazonProductVariantsUseCase : AsyncUseCase<RewardResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val rewardId: Int,
        val externalProductId: String
    )

    private val getAmazonProductVariantsService: GetAmazonProductVariantsService = GetAmazonProductVariantsServiceImpl()

    override suspend fun run(params: Params): Result<RewardResponseModel> {
        return getAmazonProductVariantsService.getAmazonProductVariants(
            overrideHeaders = params.overrideHeaders,
            rewardId = params.rewardId,
            externalProductId = params.externalProductId
        )
    }
}
